"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Représente le bouton «Back to top».
 *
 * @export
 * @class BackToTop
 */
class BackToTop {
    dernierWindowScrollY;
    node;
    /**
     * Créer une instance de BackToTop.
     * @memberof BackToTop
     */
    constructor() {
        this.dernierWindowScrollY = window.scrollY;
    }
    /**
     * Initier le bouton «Back to top».
     *
     * @memberof BackToTop
     */
    init() {
        this.ajouterListeners();
    }
    /**
     * Ajouter les listeners.
     *
     * @private
     * @memberof BackToTop
     */
    ajouterListeners() {
        window.addEventListener("scroll", () => { this.gererScroll(); });
    }
    /**
     * Gérer le bouton «Back to top» en fonction de la direction ainsi que de la
     * position du scroll.
     *
     * Le bouton n'apparaît seulement que si l'on scroll vers le haut et que l'on
     * est au moins à une pleine fenêtre de distance du haut de la page.
     *
     * @private
     * @memberof BackToTop
     */
    gererScroll() {
        const windowScrollY = window.scrollY;
        const isScrollVersLeHaut = this.isScrollVersLeHaut(windowScrollY, this.dernierWindowScrollY);
        const isEnPosition = this.isEnPosition(windowScrollY);
        if (isScrollVersLeHaut && isEnPosition) {
            if (this.node === undefined) {
                this.node = this.ajouterBackToTop();
            }
        }
        else if (this.node) {
            this.node = this.retirerBackToTop();
        }
        this.dernierWindowScrollY = windowScrollY;
    }
    /**
     * Vérifier si l'on scroll vers le haut.
     *
     * @private
     * @param {number} windowScrollY Position actuelle du scroll.
     * @param {number} dernierWindowScrollY Dernière position du scroll.
     * @returns {boolean} Est-ce que l'on scroll vers le haut?
     * @memberof BackToTop
     */
    isScrollVersLeHaut(windowScrollY, dernierWindowScrollY) {
        return dernierWindowScrollY > windowScrollY;
    }
    /**
     * Vérifier si l'on est en position.
     *
     * On est en position si l'on est au moins à une pleine fenêtre de distance du
     * haut de la page.
     *
     * @private
     * @param {number} windowScrollY Position actuelle du scroll.
     * @returns {boolean} Sommes-nous en position?
     * @memberof BackToTop
     */
    isEnPosition(windowScrollY) {
        return windowScrollY > window.innerHeight;
    }
    /**
     * Ajouter le bouton «Back to top» au DOM de la page.
     *
     * @private
     * @returns {HTMLAnchorElement} L'HTMLAnchorElement qu'incarne le bouton «Back to top».
     * @memberof BackToTop
     */
    ajouterBackToTop() {
        const backToTop = document.createElement("a");
        backToTop.classList.add("btn", "btn--back-to-top");
        backToTop.href = "#";
        document.body.appendChild(backToTop);
        return backToTop;
    }
    /**
     * Retirer le bouton «Back to top» du document.
     *
     * @private
     * @returns {undefined} Le bouton «Back to top» suite à son retrait du document.
     *                      C'est-à-dire undefined.
     * @memberof BackToTop
     */
    retirerBackToTop() {
        if (this.node) {
            document.body.removeChild(this.node);
        }
        return undefined;
    }
}
exports.default = BackToTop;
